<template>
  <v-dialog
    v-model="display"
    persistent
    max-width="800px"
    scrollable
    v-if="display"
  >
    <v-form ref="procedureForm">
      <v-card min-height="200px">
        <v-card-title>
          <v-row>
            <v-col class="headline mb-0 pb-0">Gestion de la visite</v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="text--primary">
          <ResumeDossier :dossier="dossier" title="Ce dossier concerne :" />
          <v-container>
            <v-row>
              <v-col><v-divider></v-divider></v-col>
            </v-row>
            <v-row>
              <v-col class="text-subtitle-1 mt-0 pt-0 mb-0 pb-0">
                Organiser une visite de l'officine :
              </v-col>
            </v-row>
            <v-row>
              <v-col class="mt-0 pt-0 mb-0 pb-0">
                <DateWidget
                  :date="avis.visite.dateLimite"
                  title="Date limite pour la visite"
                  :mandatory="true"
                  v-on:update:date="avis.visite.dateLimite = $event"
                />
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
            <v-row>
              <v-col><v-divider></v-divider></v-col>
            </v-row>
            <v-row>
              <v-col class="text-subtitle-1 mt-0 pt-0 mb-0 pb-0">
                Conseiller universitaire
              </v-col>
            </v-row>
            <v-row>
              <v-col class="mt-0 pt-0 mb-0 pb-0">
                <v-text-field
                  label="Nom"
                  v-model="avis.visite.cuNom"
                  :rules="cuNomRules"
                >
                  <template v-slot:append-outer>
                    <v-icon color="red" small>mdi-star-circle</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col class="mt-0 pt-0 mb-0 pb-0">
                <v-text-field
                  label="Prénom"
                  v-model="avis.visite.cuPrenom"
                  :rules="cuPrenomRules"
                >
                  <template v-slot:append-outer>
                    <v-icon color="red" small>mdi-star-circle</v-icon>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="mt-0 pt-0 mb-0 pb-0">
                <v-text-field
                  label="Adresse de messagerie"
                  v-model="avis.visite.cuEmail"
                  :rules="cuEmailRules"
                >
                  <template v-slot:append-outer>
                    <v-icon color="red" small>mdi-star-circle</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col class="mt-0 pt-0 mb-0 pb-0">
                <v-text-field
                  label="Téléphone"
                  v-model="avis.visite.cuTel"
                  :rules="cuTelRules"
                >
                  <template v-slot:append-outer>
                    <v-icon color="red" small>mdi-star-circle</v-icon>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col><v-divider></v-divider></v-col>
            </v-row>
            <v-row>
              <v-col class="text-subtitle-1 mt-0 pt-0 mb-0 pb-0">
                Conseiller d'officine
              </v-col>
            </v-row>
            <v-row>
              <v-col class="mt-0 pt-0 mb-0 pb-0">
                <v-text-field
                  label="Nom"
                  v-model="avis.visite.coNom"
                  :rules="coNomRules"
                >
                  <template v-slot:append-outer>
                    <v-icon color="red" small>mdi-star-circle</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col class="mt-0 pt-0 mb-0 pb-0">
                <v-text-field
                  label="Prénom"
                  v-model="avis.visite.coPrenom"
                  :rules="coPrenomRules"
                >
                  <template v-slot:append-outer>
                    <v-icon color="red" small>mdi-star-circle</v-icon>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="mt-0 pt-0 mb-0 pb-0">
                <v-text-field
                  label="Adresse de messagerie"
                  v-model="avis.visite.coEmail"
                  :rules="coEmailRules"
                >
                  <template v-slot:append-outer>
                    <v-icon color="red" small>mdi-star-circle</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col class="mt-0 pt-0 mb-0 pb-0">
                <v-text-field
                  label="Téléphone"
                  v-model="avis.visite.coTel"
                  :rules="coTelRules"
                >
                  <template v-slot:append-outer>
                    <v-icon color="red" small>mdi-star-circle</v-icon>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col><v-divider></v-divider></v-col>
            </v-row>
            <v-row>
              <v-col class="text-subtitle-1 mt-0 pt-0 mb-0 pb-0">
                Adresses de courriel en copie
              </v-col>
            </v-row>
            <v-row v-if="additionalMails.length === 0">
              <v-col class="text--disabled">Aucune adresse en copie.</v-col>
            </v-row>
            <v-row v-else>
              <v-col>
                <v-data-table
                  :headers="additionalMailHeaders"
                  :items="additionalMails"
                  :hide-default-footer="true"
                >
                  <template v-slot:[`item.action`]="{ item }">
                    <v-btn icon @click="deleteCCMail(item.email)">
                      <v-icon>mdi-minus</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
              <v-spacer />
            </v-row>
            <v-row
              ><v-col>
                <v-text-field
                  label="Ajouter une adresse en copie"
                  v-model="newMail"
                >
                  <template v-slot:append-outer>
                    <v-btn
                      icon
                      @click="addCCMail()"
                      color="primary"
                      :disabled="!isEmailValid(newMail)"
                    >
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>
              <v-spacer />
            </v-row>
            <v-row>
              <v-col><v-divider></v-divider></v-col>
            </v-row>
            <v-row v-if="avis.visite && avis.visite.compteRendu" class="mt-0">
              <v-col>
                <span class="subtitle-2">Compte-rendu : </span>
                <a :href="getCRURL()" class="subtitle-2" download>
                  {{ avis.visite.compteRendu.name }}
                </a>
              </v-col>
            </v-row>
            <v-row class="mt-0">
              <v-col class="mt-0 pt-0 mb-0 pb-0">
                <v-file-input
                  v-model="avis.visite.fichierCR"
                  :label="labelFileUpload"
                  @change="selectFile"
                  show-size
                  clearable
                >
                </v-file-input>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <p v-if="!formValid" class="text-caption red--text">
            Un ou plusieurs champs sont mal renseignés
          </p>
          <v-spacer></v-spacer>
          <v-btn
            small
            class="white--text"
            @click="sendAction('enregistrer')"
            color="primary"
          >
            Enregistrer
          </v-btn>
          <v-btn
            small
            class="white--text"
            @click="sendAction('supprimer')"
            color="primary"
          >
            Supprimer
          </v-btn>
          <v-btn
            small
            class="white--text"
            @click="displayed = false"
            color="primary"
          >
            Annuler
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import common from "@/common";
import ApiAvisRPORepository from "@/repositories/ApiAvisRPORepository";

import DateWidget from "@/components/DateWidget";
import ResumeDossier from "@/components/ResumeDossier";

export default {
  name: "ModalEditAvisRPO",
  components: { DateWidget, ResumeDossier },
  props: ["avis", "dossier", "display"],
  data() {
    return {
      newMail: null,
      additionalMails: this.avis.visite.additionalMails,
      additionalMailHeaders: [
        {
          text: "Adresse",
          align: "start",
          sortable: false,
          value: "email"
        },
        {
          text: "Action",
          align: "start",
          sortable: false,
          value: "action"
        }
      ],
      formValid: true,
      fileData: null,
      cuNomRules: [
        v => !!v || "Vous devez renseigner le nom du conseiller universitaire."
      ],
      cuPrenomRules: [
        v =>
          !!v || "Vous devez renseigner le prénom du conseiller universitaire."
      ],
      cuEmailRules: [
        v =>
          (!!v && this.isEmailValid(v)) ||
          "Vous devez renseigner l'adresse de courriel du conseiller universitaire."
      ],
      cuTelRules: [
        v =>
          !!v ||
          "Vous devez renseigner le numéro de téléphone du conseiller universitaire."
      ],
      coNomRules: [
        v => !!v || "Vous devez renseigner le nom du conseiller d'officine."
      ],
      coPrenomRules: [
        v => !!v || "Vous devez renseigner le prénom du conseiller d'officine."
      ],
      coEmailRules: [
        v =>
          (!!v && this.isEmailValid(v)) ||
          "Vous devez renseigner l'adresse de courriel du conseiller d'officine."
      ],
      coTelRules: [
        v =>
          !!v ||
          "Vous devez renseigner le numéro de téléphone du conseiller d'officine."
      ]
    };
  },
  computed: {
    displayed: {
      get() {
        return this.display;
      },
      set(value) {
        this.$emit("update:display", value);
      }
    },
    labelFileUpload() {
      if (this.avis.visite && this.avis.visite.compteRendu)
        return "Modifier le compte-rendu...";
      return "Ajouter le compte-rendu...";
    }
  },
  methods: {
    sendAction(action) {
      if (this.$refs.procedureForm.validate()) {
        this.formValid = true;
        this.avis.action = action;
        this.avis.visite.additionalMails = this.additionalMails;
        this.$emit("ModalAvisRPOAction", this.avis);
        this.displayed = false;
        this.$toast.success("La demande de visite a été enregistrée");
      } else {
        this.formValid = false;
      }
    },
    selectFile(file) {
      this.fileData = file;
    },
    getCRURL() {
      return ApiAvisRPORepository.getCRURL(this.avis.id);
    },
    isEmailValid(email) {
      return common.isEmailValid(email);
    },
    addCCMail() {
      if (
        0 === this.additionalMails.filter(e => e.email === this.newMail).length
      ) {
        this.additionalMails.push({
          email: this.newMail
        });
        this.newMail = null;
      }
    },
    deleteCCMail(email) {
      this.additionalMails = this.additionalMails.filter(
        e => e.email !== email
      );
    }
  }
};
</script>
